import { useState } from 'react'
import { LogoutModal, HandleLogoutModal, ProfileModal, HandleProfileModal } from '../Types/types'

export function useLogoutModal() {
  const [logoutModal, setVisible] = useState<LogoutModal>(false)

  const handleLogoutModal: HandleLogoutModal = () => {
    setVisible(!logoutModal)
  }

  return { logoutModal, handleLogoutModal }
}

export function useProfileModal() {
  const [profileModal, setVisible] = useState<ProfileModal>(false)

  const handleProfileModal: HandleProfileModal = () => {
    setVisible(!profileModal)
  }

  return { profileModal, handleProfileModal }
}
